import { ShirtspaceResponseMessage } from "@services/ShirtspaceService/ShirtspaceService.types";

const FieldError: React.FC<{
  fieldError?: ShirtspaceResponseMessage;
}> = ({ fieldError }) => {
  if (!fieldError) return null;
  return (
    <span className="text-red200 leading-none text-[10px] font-bold block uppercase">
      {fieldError.text}
    </span>
  );
};

export default FieldError;
